//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
var defaultImg = '//res.cdn.changbaimg.com/-/35639bb377ebda0b/logo_new.png';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('img', _vm._g(_vm._b({
    attrs: {
      "src": _vm.imgSrc
    },
    on: {
      "error": _vm.onError
    }
  }, 'img', _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns = [];
export default defineComponent({
  render,
  name: 'CbImage',
  props,
  data() {
    return {
      imgSrc: ''
    };
  },
  watch: {
    src: {
      immediate: true,
      handler(newSrc) {
        if (newSrc) {
          this.imgSrc = this.specific ? this.avatarAdaptor(newSrc) : newSrc;
        }
      }
    }
  },
  methods: {
    onError(event) {
      if (event.type !== 'error' && !this.isValidateUrl() && !this.specific) {
        return;
      }
      var img = new Image();
      img.src = this.avatarAdaptor(this.src, this.size);
      img.style.visibility = 'hidden';
      img.onload = () => {
        this.imgSrc = img.src;
        img.parentElement.removeChild(img);
      };
      document.body.appendChild(img);
      img.onerror = () => {
        img.parentElement.removeChild(img);
        if (this.fallback) {
          this.imgSrc = typeof this.fallback !== 'string' ? defaultImg : this.fallback;
        }
      };
    },
    isValidateUrl() {
      return !/(https?:\/\/)?aliimg\.changba\.com/.test(this.src);
    },
    avatarAdaptor(url, size) {
      if (size === void 0) {
        size = 200;
      }
      // 如果不是图片路径
      if (!/\.(jpe?g)|(png)|(gif)$/.test(url)) {
        return url;
      }
      var sizeExt = "_" + size + "_" + size;
      var lastPtIdx = url.lastIndexOf('.');
      var prefix = url.slice(0, lastPtIdx);
      var suffix = url.slice(lastPtIdx + 1);
      var distUrl = prefix + sizeExt + '.' + suffix;
      return distUrl;
    }
  }
});